import React, { useContext } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import { Form } from 'semantic-ui-react'
import SilageStepLayout from '../../SilageStepLayout'
import { StyledGroup } from '../style'
import OrganicFertilizers from './OrganicFertilizers'
import MineralFertilizers from './MineralFertilizers'
import { ClimaOptionsContext } from '..'
import LinkPopup from '../LinkPopup'
import InfoPopup from '~/components/InfoPopup'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'

const SecondGrassStep: React.FC = () => {
  const { control } = useFormContext()
  const options = useContext(ClimaOptionsContext)

  const watchGrassLandAreas = useWatch({ control, name: 'grassSilage.grasslandGrazed' })

  function renderGrassAreaFields() {
    return <Form.Group style={{ gap: 50 }}>
      <FormFields.Input
        control={control}
        withoutAsterisk
        noErrorMessage
        rules={{
          required: true
        }}
        suffix={' ha'}
        label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{'Beweidete Fläche'}</label>
          <InfoPopup
            content='Bitte tragen Sie in dieses Feld nur die Flächen ein, die auch für die Herstellung von Grassilage relevant sind. Die beweidete Fläche darf nicht größer sein als Ihre gesamte Anbaufläche für Grassilage.'
            styleIcon={{ cursor: 'pointer', fontSize: '1.3em' }}
            position={'top center'}
          />
        </div>}
        name={'grassSilage.grazedArea'}
        placeholder={'in ha'}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        withoutAsterisk
        noErrorMessage
        name={'grassSilage.dailyGrazingTime'}
        suffix=' Stunde(n)'
        label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{'Tägliche Weidedauer'}</label>
          <LinkPopup
            content='Weidetagebuch'
          />
        </div>}
        placeholder={'in Studen'}
        rules={{
          required: true
        }}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        withoutAsterisk
        label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{'Weidetage je Jahr'}</label>
          <LinkPopup
            content='Weidetagebuch'
          />
        </div>}
        suffix=' Tag(e)'
        placeholder={'in Tage'}
        name={'grassSilage.grazingDaysPerYear'}
        noErrorMessage
        rules={{
          required: true
        }}
        typeInput={'controled'}
      />
      <FormFields.Input
        control={control}
        label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{'Tierbesatz'}</label>
          <InfoPopup
            content='Angaben sind in Großvieheinheiten (GV). Eine Kuh ist 1.2 GV. Ein Kalb bis 6 Monate entspricht 0,3 GV und ein Rind zwischen 6 und 24 Monaten entspricht 0,6 GV.'
            styleIcon={{ cursor: 'pointer', fontSize: '1.3em' }}
            position={'top center'}
          />
          <ErrorIcon
            control={control}
            name={'grassSilage.animalDensity'}
          />
        </div>}
        name={'grassSilage.animalDensity'}
        suffix=' GV/ha'
        placeholder={'in GV/ha'}
        withoutAsterisk
        allowDecimals
        decimalScale={1}
        noErrorMessage
        rules={{
          required: true,
          validate: (value) => {
            const transformValue = typeof (value) === 'string' ? parseFloat(value.replace(',', '.')) : value
            if (transformValue >= 100 || transformValue < 1) {
              return 'Der Tierbesatz muss zwischen 1 und 99 GV/ha liegen.'
            }
            return true
          }
        }}
        typeInput={'controled'}
      />
    </Form.Group>
  }

  function renderForm() {
    return <>
      <FormFields.Checkbox
        defaultValue={0}
        checkboxValue={1}
        label={'Wurden die Grünlandflächen beweidet?'}
        control={control}
        name={'grassSilage.grasslandGrazed'}
      />
      {Boolean(watchGrassLandAreas) && renderGrassAreaFields()}
    </>
  }

  return (
    <SilageStepLayout
      infoText={`<div>Füllen Sie die Felder für <strong>beweidete Flächen</strong> aus, wobei die tierischen <strong>Nährstoffausscheidungen</strong> automatisch zur Düngung 
        hinzugerechnet werden. Wählen Sie <strong>alle ausgebrachten Düngemittel</strong> aus. Tragen Sie für jedes Düngemittel die 
        <strong>Ausbringmenge</strong> und die <strong>Ausbringtechnik</strong> ein und achten Sie dabei auf die korrekten <strong>Einheiten</strong>. Diese Daten sind wesentlich 
        für die Berechnung der <strong>Treibhausgasemissionen</strong> aus der Düngung (Lachgas, CO<sub>2</sub> aus Carbonat/Harnstoff, 
        Emissionen aus der Herstellung mineralischer Düngemittel).`}
    >
      <StyledGroup style={{ flexDirection: 'column', gap: '1em' }}>
        {renderForm()}
      </StyledGroup>
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <MineralFertilizers options={options} mineralKey='grassSilage.mineralFertilizers' />
      </StyledGroup>
      <StyledGroup style={{ display: 'block', minHeight: 200 }}>
        <OrganicFertilizers options={options} organicKey='grassSilage.organicFertilizers' silageKey={'grass'} />
      </StyledGroup>
    </SilageStepLayout>
  )
}

export default SecondGrassStep